import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { EndpointsService } from "../../../services/endpoints.service";
import { HttpApiService } from "../../../services/http-api.service";
import { ProfilesService } from "../../../services/profiles.service";
import { Constants } from "../../../services/constants";
@Component({
  selector: 'app-edit-rfq',
  templateUrl: './edit-rfq.component.html',
  styleUrls: ['./edit-rfq.component.css']
})
export class EditRfqComponent implements OnInit {
  requestForQ;
  rFQId;
  requiredRFQ;
  quote: any = {};
  buyerUser: any = { address: {} };
  optionsModel: any = { quoteOptions: [] };

  quoteOptions: Array<any>;
  selectedItems = [];

  constructor(private endpoints: EndpointsService,
    private profileService: ProfilesService,
    private Api: HttpApiService, private activatedRoute: ActivatedRoute) {
  }
  ngOnInit() {
    this.rFQId = this.activatedRoute.snapshot.params['id'];
    this.getRFQById();
    this.quoteOptions = [{ id: 0, name: 'New Customer for Product' },
    { id: 1, name: 'Existing Customer' },
    { id: 2, name: 'New Department/Division' }];
  }
  getRFQById() {
    this.Api.get(this.endpoints.getRequestForQuoteUrl() + `/${this.rFQId}`, true)
      .subscribe(res => {
        this.requiredRFQ = res;
        this.updateForm();
      }, error => {
        console.log("error" + error.status);
      });
  }
  updateForm() {
    this.quote.isRespondToRFP = this.requiredRFQ.isRespondToRFP
    this.quote.submissionDeadline = this.requiredRFQ.submissionDeadline
    this.quote.numberOfUsers = this.requiredRFQ.productUsers
    this.quote.purchaseTimeEstimate = this.requiredRFQ.purchaseTimeEstimate
    this.buyerUser.phoneNumber = this.requiredRFQ.phoneNumber
    this.buyerUser.department = this.requiredRFQ.buyerDepartment
    this.buyerUser.city = this.requiredRFQ.city
    this.buyerUser.state = this.requiredRFQ.state
    this.buyerUser.country = this.requiredRFQ.country

  }
  updateRFQ(quote, buyer) {
    let lead: any = {
      buyer: { user: { address: { city: buyer.city, country: buyer.country, state: buyer.state } }, primaryContact: buyer.phoneNumber, department: buyer.department, },
      date: Date.now(),
      purchaseTimeEstimate: quote.purchaseTimeEstimate,
      isRespondToRFP: quote.isRespondToRFP,
      submissionDeadline: quote.submissionDeadline,
      quoteTypes: this.selectedItems
    };
    this.submitQuote(lead);
  }
  submitQuote(lead) {
    this.Api.put(this.endpoints.getRequestForQuoteUrl() + `/${this.rFQId}`, lead, true)
      .subscribe(res => {
        console.log(res);
      }, error => {
        console.log(error);
      });
  }
  updateSelectedItems() {
    this.selectedItems = [];
    this.optionsModel['quoteOptions']
      .forEach(item => {
        this.quoteOptions.forEach(item1 => {
          if (item.id === item1.id) {
            this.selectedItems.push({ type: item1.name });
          }
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/edit-rfq/edit-rfq.component.ts